import React from "react";
// import {icons} from '../../assets/images/icons/index';
import svgIcons from "./app-icon/svgs";

const AppIcon = ({
  name,
  size = 20,
  className = "",
  direction,
  ...restProps
}) => {
  const hasExplicitColorClass =
    /(?:^|\s)!?(?:[\w-]+:)*text-[^\s]+/.test(className) ||
    /(?:^|\s)!?(?:[\w-]+:)*fill-[^\s]+/.test(className) ||
    /(?:^|\s)!?(?:[\w-]+:)*stroke-[^\s]+/.test(className);

  const directionRotation = {
    up: "rotate-0",
    right: "rotate-90",
    down: "rotate-180",
    left: "-rotate-90",
  };

  const Icon = svgIcons[name];

  if (!Icon) return null;

  return (
    <Icon
      width={size}
      height={size}
      className={`app-icon-svg ${
        hasExplicitColorClass ? "app-icon-explicit-color" : ""
      } inline-block shrink-0 transition-transform duration-200 hover:transform-scale-125 ${
        directionRotation[direction] || ""
      } ${className || ""}`}
      style={{ width: `${size}px`, height: `${size}px`, display: "block" }}
      {...restProps}
    />
  );
};

export default AppIcon;
